import React from 'react';

export const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: 'h-6',
    default: 'h-10',
    large: 'h-14',
    xlarge: 'h-20'
  };
  return (
    <img 
      src="/images/logo.png" 
      alt="BELLAJA Electric" 
      className={`${sizes[size] || sizes.default} object-contain ${className}`}
    />
  );
};
